<template>
  <div id="page-gesture" class="gesture" v-show="pageLoading">
    <van-nav-bar
      class="login-nav"
      :title="pageTitle"
      :z-index="10"
      @click-left="goLogin"
      left-arrow></van-nav-bar>

    <div class="gesture-logo">
      <img src="../../assets/img/tiananjs-logo-1.png" alt />
    </div>

    <div class="masks">
      <div class="gesturePwd">
        <div>
          <h2 class="gesture-title">{{ hint }}</h2>

          <!-- 手势密码 -->
          <canvas ref="canvas" class="gesture-canvas"></canvas>
        </div>
      </div>
    </div>

    <div class="forget-the-password" v-if="objForgetPassword.show">
      <span @click="onForgetPassword">忘记密码?</span>
    </div>
  </div>
</template>

<script>
import { NavBar, Toast, Dialog } from "vant"
import * as CustApi from "@/api/cust"
import storage from "@/utils/storage"
import { mapMutations, mapGetters, mapActions } from "vuex"

export default {
  components: {
    [NavBar.name]: NavBar,
    [Toast.name]: Toast,
    [Dialog.name]: Dialog
  },
  data() {
    return {
      from: "",
      ctx: "",
      width: 0,
      height: 0,
      devicePixelRatio: 0,
      chooseType: "",
      r: "", // 公式计算
      lastPoint: [],
      arr: [],
      restPoint: [],
      pswObj: { step: 2 },
      canvas: "",

      pageLoading: false,
      pageTitle: "绘制手势密码",
      hint: "请绘制您的手势密码",
      loginForm: {
        loading: false,
        field: {
          mobile: "",
          handpwd: "",
          loginCode: "",
          loginType: "FLTC"
        }
      },

      objForgetPassword: {
        show: false,
        fromForgetPassword: false //   从 `忘记手势密码` -> `注册登录` 过来的
      }
    }
  },

  watch: {},

  created() {
    let user_info = storage.getJson("user-info")
    let cache_info = storage.getJson("cache-info")
    console.log(cache_info)
    let token = storage.get("app-token")
    if (!user_info || !cache_info) {
      this.$router.replace("/login")
      return
    }
    this.from = this.$route.query.from

    /**
     * 在已登录的情况下, 且不是从 `设置->密码管理` 页面过来的,
     * 则立即重定向到往首页 。
     *
     */
    if (
      token &&
      user_info &&
      user_info.loginType === "FLTC" &&
      this.from !== "options"
    ) {
      this.$router.replace("/home")
      return
    }

    //  仅 token 超时的时候 , 显示 `忘记密码` 的入口
    if (user_info && user_info.loginType === "FLTC") {
      this.objForgetPassword.show = true
    }

    // 是从 `忘记密码` 的入口前往了登录页, 再从登录页回到了 `手势密码绘制页`
    let appForgetPassword = storage.get("app-forget-password")
    if (appForgetPassword) {
      storage.del("app-forget-password")
      this.objForgetPassword.show = false //  重置为 false
      this.objForgetPassword.fromForgetPassword = true //  重置为 false
      this.pageTitle = "重置手势密码"
      this.hint = "请重置您的手势密码"
    }

    /**
     * 为避免页面闪烁, 通过设置pageLoading来控制页面的显示与隐藏
     *
     */
    this.pageLoading = true
  },

  mounted() {
    this.init()
    this._dismissLoading()
  },

  computed: {
    ...mapGetters(["userInfo", "channel"])
  },

  methods: {
    ...mapMutations(["setToken", "setUserInfo"]),
    ...mapActions(["getUserInfo"]),

    // 忘记密码
    onForgetPassword() {
      this.$store.commit("logout")
      storage.set("app-forget-password", "yes") // 是从 `忘记密码` 的入口前往了登录页
      this.$router.replace("/login")
    },

    goLogin() {
      if (this.from === "options") {
        this.goableBack()
        return
      } else {
        storage.del("user-info")
        storage.del("app-token")
        this.$router.replace("/login")
      }
    },

    onSubmit() {
      let user_info = storage.getJson("user-info")
      let cache_info = storage.getJson("cache-info")
      let token = storage.get("app-token")
      let is_newbie = user_info && !user_info.loginType //  从未绘制过手势的用户
      let handpwd = this.pswObj.spassword.map((item, index) => {
        return item.index
      })

      Object.assign(this.loginForm.field, {
        mobile: cache_info.mobile,
        handpwd: handpwd + "",
        loginCode: handpwd + ""
      })

      // 以下情况需要使用注册手势密码的流程 :
      // -    从 `设置页` -> `设置手势密码` 过来的
      // -    新用户从 `注册登录` 过来的
      // -    从 `忘记手势密码` -> `注册登录` 过来的
      if (
        this.$route.query.from === "options" ||
        is_newbie ||
        this.objForgetPassword.fromForgetPassword
      ) {
        this.onSMSReg()
      } else {
        this.onSMSLogin()
      }
    },

    // 调用登录接口开始登录
    onSMSLogin() {
      let sendForm = this.loginForm.field

      this._showLoading()
      CustApi.login(sendForm)
        .then((data) => {
          this._dismissLoading()
          if (!data) {
            Toast("服务器繁忙, 请稍后再试")
            return
          }

          this.setToken(data)
          this.onGetUserInfo()
          this.resetPassword()
        })
        .catch((e) => {
          this._dismissLoading()
          Toast(e.msg || e.message)
          this.resetPassword()
        })
    },

    onGetUserInfo() {
      const user_info = storage.getJson("user-info")
      let _this = this
      _this
        .getUserInfo()
        .then((data) => {
          // 假设 query 含有 redirect, 则前往 redirect,
          // 否则则判断用户是否 `首次登录`
          // 是则 `首次登录引导` , 否则前往  `首页`
          if (this.userInfo.isNew && this.userInfo.isProm === 0) {
            let chanlCode =
              this.$route.query.chanlCode || this.$route.params.channel
            return this.$router.push({ path: "/home", query: { chanlCode } })
          } else if (_this.$route.query && _this.$route.query.redirect) {
            _this.$router.replace(_this.$route.query.redirect)
          } else if (user_info && Number(user_info.loginTimes) >= 2) {
            _this.$router.replace({
              path: "/home",
              query: { chanlCode: _this.channel }
            })
          } else {
            _this.$router.replace({
              path: "/home",
              query: { chanlCode: _this.channel }
            })
          }
          _this.resetPassword()
        })
        .catch((e) => {
          Toast(e.msg || e.message)
        })
    },

    // 调用注册接口开始登录
    onSMSReg() {
      const user_info = storage.getJson("user-info")
      let sendForm = {
        handpwd: this.loginForm.field.handpwd
      }
      CustApi.sethandpwd(sendForm)
        .then((data) => {
          // 假设 query 含有 redirect, 则前往 redirect,
          // 否则则判断用户是否 `首次登录`
          // 是则 `首次登录引导` , 否则前往  `首页`
          if (user_info && Number(user_info.loginTimes) >= 2) {
            this.$router.replace({
              path: "/home",
              query: { chanlCode: this.channel }
            })
          } else {
            this.$router.replace({
              path: "/home",
              query: { chanlCode: this.channel }
            })
          }
          this.resetPassword()
        })
        .catch((e) => {
          Toast(e.msg || e.message)
          this.resetPassword()
        })
    },

    H5lock(obj) {
      this.height = obj.height
      this.width = obj.width
      this.devicePixelRatio = window.devicePixelRatio || 1
    },
    drawCle(x, y) {
      // 初始化解锁密码面板 小圆圈
      this.ctx.strokeStyle = "#C1A76A" //密码的点点默认的颜色
      this.ctx.lineWidth = 2
      this.ctx.beginPath()
      this.ctx.arc(x, y, this.r, 0, Math.PI * 2, true)
      this.ctx.closePath()
      this.ctx.stroke()
    },
    drawPoint(style) {
      // 初始化圆心
      for (var i = 0; i < this.lastPoint.length; i++) {
        this.ctx.fillStyle = style
        this.ctx.beginPath()
        this.ctx.arc(
          this.lastPoint[i].x,
          this.lastPoint[i].y,
          this.r / 2.5,
          0,
          Math.PI * 2,
          true
        )
        this.ctx.closePath()
        this.ctx.fill()
      }
    },
    drawStatusPoint(type) {
      // 初始化状态线条
      for (var i = 0; i < this.lastPoint.length; i++) {
        this.ctx.strokeStyle = type
        this.ctx.beginPath()
        this.ctx.arc(
          this.lastPoint[i].x,
          this.lastPoint[i].y,
          this.r,
          0,
          Math.PI * 2,
          true
        )
        this.ctx.closePath()
        this.ctx.stroke()
      }
    },
    drawLine(style, po, lastPoint) {
      //style:颜色 解锁轨迹
      this.ctx.beginPath()
      this.ctx.strokeStyle = style
      this.ctx.lineWidth = 3
      this.ctx.moveTo(this.lastPoint[0].x, this.lastPoint[0].y)

      for (var i = 1; i < this.lastPoint.length; i++) {
        this.ctx.lineTo(this.lastPoint[i].x, this.lastPoint[i].y)
      }
      this.ctx.lineTo(po.x, po.y)
      this.ctx.stroke()
      this.ctx.closePath()
    },
    createCircle() {
      // 创建解锁点的坐标，根据canvas的大小来平均分配半径
      var chooseType = 3
      var count = 0
      this.r = this.ctx.canvas.width / (2 + 4 * chooseType) // 公式计算
      this.lastPoint = []
      this.arr = []
      this.restPoint = []
      var r = this.r
      for (var i = 0; i < chooseType; i++) {
        for (var j = 0; j < chooseType; j++) {
          count++
          var obj = {
            x: j * 4 * r + 3 * r,
            y: i * 4 * r + 3 * r,
            index: count
          }
          this.arr.push(obj)
          this.restPoint.push(obj)
        }
      }
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)

      for (var i = 0; i < this.arr.length; i++) {
        this.drawCle(this.arr[i].x, this.arr[i].y)
      }

      //return arr;
    },
    getPosition(e) {
      // 获取touch点相对于canvas的坐标
      var rect = e.currentTarget.getBoundingClientRect()
      var po = {
        x: (e.touches[0].clientX - rect.left) * this.devicePixelRatio,
        y: (e.touches[0].clientY - rect.top) * this.devicePixelRatio
      }
      return po
    },
    update(po) {
      // 核心变换方法在touchmove时候调用
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height)

      for (var i = 0; i < this.arr.length; i++) {
        // 每帧先把面板画出来
        this.drawCle(this.arr[i].x, this.arr[i].y)
      }

      this.drawPoint("#C1A76A") // 每帧花轨迹
      this.drawStatusPoint("#C1A76A") // 每帧花轨迹
      this.drawLine("#C1A76A", po, this.lastPoint) // 每帧画圆心

      for (var i = 0; i < this.restPoint.length; i++) {
        if (
          Math.abs(po.x - this.restPoint[i].x) < this.r &&
          Math.abs(po.y - this.restPoint[i].y) < this.r
        ) {
          this.drawPoint(this.restPoint[i].x, this.restPoint[i].y)
          this.lastPoint.push(this.restPoint[i])
          this.restPoint.splice(i, 1)
          break
        }
      }
    },
    checkPass(psw1, psw2) {
      // 检测密码
      var p1 = "",
        p2 = ""
      for (var i = 0; i < psw1.length; i++) {
        p1 += psw1[i].index + psw1[i].index
      }
      for (var i = 0; i < psw2.length; i++) {
        p2 += psw2[i].index + psw2[i].index
      }
      return p1 === p2
    },
    storePass(psw) {
      // touchend结束之后对密码和状态的处理
      console.log("[天安金交] 手势密码 : ", psw)
      if (psw && psw.length < 4) {
        Toast("密码轨迹点不少于四位")
        return
      }

      let user_info = storage.getJson("user-info")
      let token = storage.get("app-token")

      // token 过期的用户只需要手势绘制一次
      if (user_info && user_info.loginType === "FLTC") {
        this.pswObj.spassword = psw
        this.onSubmit()
        return
      }

      if (this.pswObj.step == 1) {
        if (this.checkPass(this.pswObj.fpassword, psw)) {
          this.pswObj.step = 2
          this.pswObj.spassword = psw
          this.hint = "密码保存成功"
          this.onSubmit()

          this.drawStatusPoint("#C1A76A")
          this.drawPoint("#C1A76A")
        } else {
          this.hint = "两次不一致，请重新输入"
          this.drawStatusPoint("red")
          this.drawPoint("red")
          delete this.pswObj.step
        }
      } else if (this.pswObj.step == 2) {
        if (this.checkPass(this.pswObj.spassword, psw)) {
          this.hint = "解锁成功"
          this.onSubmit()

          this.drawStatusPoint("#C1A76A") //小点点外圈高亮
          this.drawPoint("#C1A76A")
          this.drawLine(
            "#C1A76A",
            this.lastPoint[this.lastPoint.length - 1],
            this.lastPoint
          ) // 每帧画圆心

          this.closePwd()
        } else if (psw.length < 4) {
          this.drawStatusPoint("red")
          this.drawPoint("red")
          this.drawLine(
            "red",
            this.lastPoint[this.lastPoint.length - 1],
            this.lastPoint
          ) // 每帧画圆心

          this.hint = "请连接至少4个点"
        } else {
          this.drawStatusPoint("red")
          this.drawPoint("red")
          this.drawLine(
            "red",
            this.lastPoint[this.lastPoint.length - 1],
            this.lastPoint
          ) // 每帧画圆心

          this.hint = "密码错误，您还可以输入N次"
        }
      } else {
        this.pswObj.step = 1
        this.pswObj.fpassword = psw
        this.hint = "请再次输入"
      }
    },
    makeState() {
      if (this.pswObj.step == 2) {
        this.hint = "验证密码, 请绘制密码图案"
      }
    },

    // 重置密码
    resetPassword() {
      this.pswObj = {}
      this.hint = "验证密码,请绘制密码图案"
      this.reset()
    },

    initDom() {
      this.devicePixelRatio = window.devicePixelRatio || 1

      var canvas = this.$refs.canvas

      var width = this.width || 320
      var height = this.height || 320

      // 高清屏锁放
      canvas.style.width = width + "px"
      canvas.style.height = height + "px"
      canvas.height = height * this.devicePixelRatio
      canvas.width = width * this.devicePixelRatio
    },
    init() {
      this.initDom()
      this.pswObj = {}
      this.lastPoint = []
      this.makeState()
      this.touchFlag = false

      this.canvas = this.$refs.canvas

      this.ctx = this.canvas.getContext("2d")
      this.createCircle()
      this.bindEvent()
    },
    reset() {
      this.makeState()
      this.createCircle()
    },
    bindEvent() {
      var self = this
      this.canvas = this.$refs.canvas
      this.canvas.addEventListener(
        "touchstart",
        function (e) {
          e.preventDefault() // 某些android 的 touchmove不宜触发 所以增加此行代码
          var po = self.getPosition(e)

          for (var i = 0; i < self.arr.length; i++) {
            if (
              Math.abs(po.x - self.arr[i].x) < self.r &&
              Math.abs(po.y - self.arr[i].y) < self.r
            ) {
              self.touchFlag = true
              self.drawPoint(self.arr[i].x, self.arr[i].y)
              self.lastPoint.push(self.arr[i])
              self.restPoint.splice(i, 1)
              break
            }
          }
        },
        false
      )
      this.canvas.addEventListener(
        "touchmove",
        function (e) {
          if (self.touchFlag) {
            self.update(self.getPosition(e))
          }
        },
        false
      )
      this.canvas.addEventListener(
        "touchend",
        function (e) {
          if (self.touchFlag) {
            self.touchFlag = false
            self.storePass(self.lastPoint)

            setTimeout(function () {
              self.reset()
            }, 60)
          }
        },
        false
      )
    }
  }
}
</script>

<style lang="less" scoped>
@import url("./idx.less");

.forget-the-password {
  text-align: center;
  padding-bottom: 30px;
  span {
    color: rgb(217, 183, 101);
  }
}
</style>
